import React from "react";
import BottomNav from "./BottomNav";
import {useDispatch, useSelector} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import VignetteArticle from "./sub/VignetteArticle";
import {useHistory} from "react-router-dom";

function Page13() {

    let history = useHistory();

    const number_on_page = 3;

    const offset_list_capiton = useSelector( ( state ) => state.offset_list_capiton );
    const capiton_selectionne = useSelector( ( state ) => state.capiton_selectionne );
    const list_capiton = useSelector( ( state ) => state.list_capiton );

    const dispatch = useDispatch();

    const filtered_list_capiton = Object.values(list_capiton).sort((a, b) => a.prix_ttc - b.prix_ttc );;

    const count_list_capiton = filtered_list_capiton.length;

    const final_list_capiton = filtered_list_capiton.slice(offset_list_capiton, offset_list_capiton + number_on_page);

    return (
        <>
            <div className="container flex-grow-1 d-flex justify-content-center">
                <div className="mt-2 d-flex flex-grow-1 flex-column">
                    <h1 className="text-center font-gold mt-5">Choix du capiton</h1>
                    <div className="d-flex flex-grow-1">
                        <div className="row mb-5 align-content-around flex-grow-1">
                            {
                                final_list_capiton.map((value, index) => {
                                    return (
                                        <VignetteArticle
                                            key={ index }
                                            selected={ capiton_selectionne !== null && capiton_selectionne.code === value.code }
                                            onClick={ () => {
                                                dispatch({type: 'set_capiton_selectionne', payload: value });
                                                history.goBack();
                                            } }
                                            photo={ value.photo }
                                            photo_replace_text={ 'Pas de photo pour ce capiton' }
                                            nom={ value.nom }
                                            prix={ value.prix_ttc }
                                            height={ '40px' }
                                        />
                                    );
                                })
                            }
                        </div>
                    </div>
                    <div className="d-flex pb-4">
                        <div className="col-4">
                            {
                                offset_list_capiton > 0 && <button className="btn btn-primary btn-lg" onClick={ () => dispatch({ type: 'set_offset_list_capiton', payload: (offset_list_capiton - number_on_page) }) }>
                                    <FontAwesomeIcon icon={"chevron-left"} />&nbsp;&nbsp;
                                    capitons précédents
                                </button>
                            }
                        </div>
                        <div className="col-4 text-center">
                            <span className="btn btn-outline-dark btn-lg" >Page { ( offset_list_capiton / number_on_page ) + 1 }  / { Math.ceil( count_list_capiton / number_on_page )  }</span>
                        </div>
                        <div className="col-4 text-right">
                            {
                                offset_list_capiton + number_on_page < count_list_capiton && <button className="btn btn-primary btn-lg" onClick={ () => dispatch({ type: 'set_offset_list_capiton', payload: (offset_list_capiton + number_on_page) }) }>
                                    capitons suivants&nbsp;&nbsp;
                                    <FontAwesomeIcon icon={"chevron-right"} />
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        <BottomNav precedent_page={'/Page14'} suivant_enable={ false } />
        </>
    );

}

export default Page13;